//const $BASE_API = 'https://5c50050f3e81.sn.mynetname.net'; //PRODUCCION, BORRAR LUEGO DE HACER TESTS
//const $BASE_REST = `${$BASE_API}/aasa_com_yii/web`; //PRODUCCCION, BORRAR LUEGO DE HACER TESTS
//const $BASE_REST = "http://localhost/aasa_com_yii/web";
const $BASE_API = "https://aasacom.jeds.ar";
const $BASE_REST = "https://aasayii.jeds.ar/web";
const $BASE_AASA_COM = "https://aasacom.jeds.ar";
const $BASE_AASA = "https://aberturas.com.ar";
const $APP_WEB = "https://cotizador.aberturas.com.ar";
const $CARGA_WEB = "https://aasacw.jeds.ar";
const $BUSQUEDAS = "https://busquedasbackend.aberturas.com.ar/web/rrhhs";
const $DOCUMENTOS = "https://documentosaasa.jeds.ar";


export const environment = {
      production: false,
      baseRest: $BASE_REST,
      appWeb: $APP_WEB,
      configFirebase: {
            apiKey: "AIzaSyCdxgANZPCbXz0KQV6rYVy1mfBuq6dSPfg",
            authDomain: "aasa-236601.firebaseapp.com",
            projectId: "aasa-236601",
            storageBucket: "aasa-236601.appspot.com",
            messagingSenderId: "855907669144",
            appId: "1:855907669144:web:67dde6147660046c282ced",
            measurementId: "G-7HDK8HNBHK"
      },
      login: {
            users: `${$BASE_REST}/view_usuario_logins`,
            //users: `${$CARGA_WEB}/usuarios_login.php`,
            usersApp: `${$BASE_API}/estadisticas/querybloques/usuarios_app.php`,
            login: `${$BASE_REST}/usuario/login`
      },
      menu: `${$BASE_REST}/com_menus`,
      controlador: `${$BASE_AASA_COM}/controlador/`,
      busquedas: {
            postulantes: `${$BASE_AASA}/busquedas/rrhh_peticion.php`,
            puestos: `${$BASE_AASA}/busquedas/get_puesto.php`,
            ubicaciones: `${$BASE_AASA}/busquedas/get_ubicacion.php`,
            medios: `${$BASE_AASA}/busquedas/get_entero.php`,
            markDestacado: `${$BASE_AASA}/busquedas/destacar.php`,
            markVisto: `${$BASE_AASA}/busquedas/ver.php`,
            markLlamado: `${$BASE_AASA}/busquedas/llamar.php`,
            markObservado: `${$BASE_AASA}/busquedas/observar.php`,
      },
      calendario: {
            posts: `${$CARGA_WEB}/cw_post.php`,
            imagePost: `${$BASE_AASA_COM}/img/posts`,
            autorizarEvento: `${$CARGA_WEB}/cw_post_guardar.php`,
            imagenNoticia: `${$BASE_AASA_COM}/img/noticias`,
      },
      devoluciones: {
            get: `${$CARGA_WEB}/cw_remanente.php`,
            save: `${$CARGA_WEB}/cw_remanente_guardar.php`,
            delete: `${$CARGA_WEB}/cw_remanente_eliminar.php`,
            devolver: `${$CARGA_WEB}/cw_remanente_devolver.php`,
            camara: `${$CARGA_WEB}/cw_camara.php`,
            motivo: `${$CARGA_WEB}/cw_motivo.php`,
            operario: `${$CARGA_WEB}/cw_operario.php`,
            vidrio: `${$CARGA_WEB}/cw_vidrio.php`,
      },
      messages: `${$BASE_AASA}/get_message.php`,
      trazabilidad: {
            articulos: `${$CARGA_WEB}/cw_articulo_by_descripcion.php`,
            proveedores: `${$CARGA_WEB}/cw_proveedor_by_descripcion.php`,
            trazabilidad: `${$CARGA_WEB}/consultas/trazabilidad_consulta.php`,
            pdf: `${$CARGA_WEB}/consultas/mostrar_adjunto.php`,
      },
      whatsapp: `${$BASE_AASA}/sent_message.php`,
      mail: `${$BASE_AASA}/sent_mail.php`,

      api: {
            common: {
                  vendedores: `${$BASE_REST}/vendedors`,
                  localidades: `${$BASE_REST}/localidads`,
                  localidadesZonas: `${$BASE_REST}/view_localidad_zonas`,
                  notificaciones: `${$BASE_REST}/view_alertas`,
                  update_notificacion: `${$BASE_REST}/alerta_usuarios`,
                  marcar_leidas: `${$BASE_REST}/alerta_usuario/marcar_leidas`,
                  usuarios: `${$BASE_REST}/usuarios`,
                  usuario_dispositivos: `${$BASE_REST}/usuario_dispositivos`,
            },
            gerencia: {
                  estadisticas: `${$BASE_REST}/estadisticas`,
            },
            clientes: {
                  prospecto_origenes: `${$BASE_REST}/prospecto_origens`,
                  presupuesto_estados: `${$BASE_REST}/presupuesto_estados`,
                  obras: `${$BASE_REST}/obras`,
                  contadores: `${$BASE_REST}/prospecto_contadors`,
                  prospectos: `${$BASE_REST}/prospectos`,
                  vista_prospectos: `${$BASE_REST}/view_prospectos`,
                  trazabilidad: `${$BASE_REST}/view_prospecto_trazabilidad`,
                  presupuestos: `${$BASE_REST}/presupuestos`,
                  presupuestos_vista_seccion: `${$BASE_REST}/view_presupuesto_seccions`,
                  presupuesto_vista_reportes: `${$BASE_REST}/view_presupuesto_reportes`,
                  usuarios: `${$BASE_REST}/usuarios`,
                  vendedores: `${$BASE_REST}/vendedors`,
                  clientes: `${$BASE_REST}/clientes`,
                  movimientos: `${$BASE_REST}/prospecto_movimientos`,
                  prospecto_llamados: `${$BASE_REST}/prospecto_llamados`,
                  view_prospecto_asignados: `${$BASE_REST}/view_prospecto_asignados`,
                  view_presupuesto_en_procesos: `${$BASE_REST}/view_presupuesto_en_procesos`,
                  view_presupuesto_en_revision: `${$BASE_REST}/view_presupuesto_en_revision`,
                  view_presupuesto_enviados: `${$BASE_REST}/view_presupuesto_enviados`,
                  view_prospecto_perdido_no_cotizados: `${$BASE_REST}/view_prospecto_perdido_no_cotizados`,
                  view_venta_pendientes: `${$BASE_REST}/view_venta_pendientes`,
                  view_venta_en_procesos: `${$BASE_REST}/view_venta_en_procesos`,
                  view_venta_terminadas: `${$BASE_REST}/view_venta_terminadas`,//ventas entregadas
                  reporte_venta_pdf: `${$BASE_REST}/venta/reporte_venta_pdf`,
                  com_configuracion: `${$BASE_REST}/com_configuracions`,
                  presupuesto_ponderacion_ponderar: `${$BASE_REST}/presupuesto_ponderacion/ponderar`,
                  reporte_presupuesto_pdf: `${$BASE_REST}/presupuesto/reporte_presupuesto_pdf`,
                  editar_referencia_observacion: `${$BASE_REST}/prospecto/editar_referencia_observacion`,
                  total_vendido: `${$BASE_REST}/venta/vendido`,
                  prospectos_pendientes: `${$BASE_REST}/view_pendientes_por_analista/get_pendientes`,
                  presupuestos_pendientes_por_analista: `${$BASE_REST}/view_pendientes_por_analista`,
            },
            ventas: {
                  oportunidades: {
                        oportunidades: `${$BASE_REST}/oportunidads`,
                        usuario: `${$BASE_REST}/oportunidad_usuarios`,
                  },
                  mis_clientes: {
                        presupuestos: `${$BASE_REST}/presupuestos`,
                        solicitudes: `${$BASE_REST}/presupuesto_solicituds`,
                        usuarios: `${$BASE_REST}/usuarios`,
                        clientes: `${$BASE_REST}/clientes`,
                        solicitud_origenes: `${$BASE_REST}/presupuesto_solicitud_origens`,
                        solicitud_fuentes: `${$BASE_REST}/presupuesto_solicitud_fuentes`,
                        obras: `${$BASE_REST}/obras`,
                        presupuestos_importar_pvc: `${$BASE_REST}/presupuesto_importar_pvcs`,
                        presupuestos_importar_pvc_procesar_excel: `${$BASE_REST}/presupuesto_importar_pvc/procesar_excel`,
                        presupuestos_vista_seccion: `${$BASE_REST}/view_presupuesto_seccions`,
                        presupuesto_vista_reportes: `${$BASE_REST}/view_presupuesto_reportes`,
                        secciones: `${$BASE_REST}/seccions`,
                        documentos: `${$BASE_REST}/documentos`,
                        presupuestos_copia: `${$BASE_REST}/presupuesto_copias`,
                        configuracion: `${$BASE_REST}/configuracions`,
                        barrios: `${$BASE_REST}/barrios`,
                        bancos: `${$BASE_REST}/bancos`,
                        contratos: `${$BASE_REST}/contratos`,
                        forma_pago_contratos: `${$BASE_REST}/forma_pago_contratos`,
                        alternativas: `${$BASE_REST}/alternativas`,
                        ubicaciones: `${$BASE_REST}/ubicacions`,
                        abertura_otras: `${$BASE_REST}/aberturaotras`,
                        abertura_editable_chapa: {
                              ubicacions: `${$BASE_REST}/ubicacions`,
                              aberturaeditablechapa: `${$BASE_REST}/aberturachapas`,
                              categoria_vidrios: `${$BASE_REST}/categoriavidrios`,
                        },
                        abertura_editable: `${$BASE_REST}/aberturamanual`,
                        abertura_editable_calcular: `${$BASE_REST}/aberturamanual/calcular`,
                        componente_editables: `${$BASE_REST}/componente_editables`,
                        componente_editables_total: `${$BASE_REST}/componente_editable/total_componentes`,
                        itemalternativas: `${$BASE_REST}/itemalternativas`,
                        itemalternativa_clonar: `${$BASE_REST}/itemalternativa/clonar`,
                        ventas: `${$BASE_REST}/view_ventas`,
                        terminar_venta: `${$BASE_REST}/venta/terminar`,
                        presupuesto_enviar_email: `${$BASE_REST}/presupuesto/enviar_email`,
                        enviar_whatsapp: `${$BASE_REST}/presupuesto/enviar_whatsapp`,
                  },
                  prospectos: {
                        prospectos: `${$BASE_REST}/view_prospectos`,
                        estados: `${$BASE_REST}/presupuesto_estados`,
                        movimientos: `${$BASE_REST}/prospecto_movimientos`,
                        contadores: `${$BASE_REST}/view_prospecto_contadors`,
                        trazabilidad: `${$BASE_REST}/view_prospecto_trazabilidad`,
                        prospecto_llamados: `${$BASE_REST}/prospecto_llamados`,
                        documentos_prospectos_planos: `${$DOCUMENTOS}/presupuestos/planos`,
                        presupuestos_vista_seccion: `${$BASE_REST}/view_presupuesto_seccions`,
                        presupuesto_vista_reportes: `${$BASE_REST}/view_presupuesto_reportes`,
                        presupuestos: `${$BASE_REST}/presupuestos`,
                        actualizar_plus_localidad: `${$BASE_REST}/presupuesto/actualizar_plus_localidad`,
                  },
                  seguimiento_profesionales: {
                        encuestas: `${$BASE_REST}/cliente_encuestas`,
                        profesiones: `${$BASE_REST}/profesions`,
                        usuarios: `${$BASE_REST}/usuarios`,
                        clientes: `${$BASE_REST}/view_clientes`,
                        obras: `${$BASE_REST}/obras`,
                        visitas: `${$BASE_REST}/visitas`,
                        com_configuracion: `${$BASE_REST}/com_configuracions`,
                  },
                  visitas: {
                        get_con_horarios_por_fecha: `${$BASE_REST}/view_vendedor_evento_asignacion/get_con_horarios_por_fecha`,
                        vendedor: `${$BASE_REST}/view_vendedor_evento_asignacion/get_vendedor`,
                        tipo_evento: `${$BASE_REST}/com_configuracion/get_tipo_evento_vendedor`,
                        vehiculo: `${$BASE_REST}/view_vendedor_evento_asignacion/get_vehiculo`,
                        evento: `${$BASE_REST}/vendedor_evento`,
                        ventas: `${$BASE_REST}/view_ventas`,
                        get_datos_evento: `${$BASE_REST}/vendedor_evento/get_datos_evento`
                  }
            },
            materiales: {
                  articulos: {
                        get_articulo_inventario: `${$BASE_REST}/view_articulo_stock_panol_detalle/get_articulo_inventario`,
                        view_articulo_stock_panol_detalle: `${$BASE_REST}/view_articulo_stock_panol_detalle`,
                        view_articulo_reporte: `${$BASE_REST}/view_articulo/reporte`,
                        view_articulos: `${$BASE_REST}/view_articulos`,
                        marcas: `${$BASE_REST}/marcas`,
                        articulos: `${$BASE_REST}/articulos`,
                        contadores: `${$BASE_REST}/view_articulo/contadores`,
                        contador: `${$BASE_REST}/view_articulo/contador`,
                        rubros: `${$BASE_REST}/rubros`,
                        sectores: `${$BASE_REST}/sector_articulos`,
                        subsectores: `${$BASE_REST}/subsector_articulos`,
                        artUnidadMedida: `${$BASE_REST}/articulo_unidad_medidas`,
                        viewArtUnidadMedida: `${$BASE_REST}/view_pro_articulo_unidad_medidas`,
                        cambiar_equivalencia: `${$BASE_REST}/view_articulo_movimiento_stock/cambiar_equivalencia`,
                        convertir_cantidad: `${$BASE_REST}/view_articulo_movimiento_stock/convertir_cantidad`,
                        artProveedores: `${$BASE_REST}/articulo_proveedors`,
                        unidadMedida: `${$BASE_REST}/unidad_medidas`,
                        proveedores: `${$BASE_REST}/proveedors`,
                        imagenes: `${$BASE_REST}/pro_imagens`,
                        movimientosGrafico: `${$BASE_REST}/view_articulo_movimiento_stocks`,
                        viewArticuloStockPanols: `${$BASE_REST}/view_pro_articulo_stock_panols`,
                        viewArticuloMovimientoStocks: `${$BASE_REST}/view_articulo_movimiento_stocks`,
                        unificar: `${$BASE_REST}/articulo/unificar`,
                  },
                  pedidos: {
                        obtener_asociados_item: `${$BASE_REST}/compras_pedido/obtener_asociados_item`,
                        empleados: `${$BASE_REST}/empleados`,
                        view_empleados: `${$BASE_REST}/view_empleado_selects`,
                        importar_pedido_pvc: `${$BASE_REST}/compras_prepedido/importar_pedido_pvc`,
                        prepedidos: `${$BASE_REST}/compras_prepedidos`,
                        items_prepedido: `${$BASE_REST}/view_prepedido_detalles`,
                        pedidos: `${$BASE_REST}/compras_pedidos`,
                        ordenesCompra: `${$BASE_REST}/compras_orden_compras`,
                        proveedores: `${$BASE_REST}/proveedors`,
                        compras_generar_pedidos: `${$BASE_REST}/compras_generar_pedidos`,
                        compras_pedido_contestar_items: `${$BASE_REST}/compras_pedido_contestar_items`,
                        compras_generar_orden_compras: `${$BASE_REST}/compras_generar_orden_compras`,
                        compras_pedido_reportes: `${$BASE_REST}/compras_pedido_reportes`,
                        compras_oc_reportes: `${$BASE_REST}/compras_orden_compra_reportes`,
                        compras_generar_pedido_restantes: `${$BASE_REST}/compras_generar_pedido_restantes`,
                        compras_pedido_enviar_email: `${$BASE_REST}/compras_pedido/enviar_email`,
                        compras_orden_compra_enviar_email: `${$BASE_REST}/compras_orden_compra/enviar_email`,
                        compras_prepedido_notificar: `${$BASE_REST}/compras_prepedido/notificar`,
                        compras_pedido_proveedors: `${$BASE_REST}/compras_pedido_proveedors`,
                        compras_pedido_especial: `${$BASE_REST}/compras_pedido/especial`,
                        compras_pedido_agregar_proveedor: `${$BASE_REST}/compras_pedido/agregar_proveedor`,
                        compras_pedido_eliminar_proveedor: `${$BASE_REST}/compras_pedido/eliminar_proveedor`,
                        compras_pedido_cambio_articulo: `${$BASE_REST}/compras_pedido/cambio_articulo`,
                        compras_pedido_cambio_proveedor: `${$BASE_REST}/compras_pedido/cambio_proveedor`,
                        eliminar_item: `${$BASE_REST}/compras_pedido/eliminar_item`,
                        agregar_item: `${$BASE_REST}/compras_pedido/agregar_item`,
                  },
                  pedidos_pvc: {
                        // Enpoint usados para los acordeones de Pedidos PVC
                        pvc_pendiente: `${$BASE_REST}/view_venta_pvc_pendiente`,
                        contador_pvc_pendiente: `${$BASE_REST}/view_venta_pvc_pendiente?contadores=1`,
                        importado: `${$BASE_REST}/view_compras_prepedido_pvc_pendientes/importado`,
                        contador_importado: `${$BASE_REST}/view_compras_prepedido_pvc_pendientes/importado?contadores=1`,
                        verificado: `${$BASE_REST}/view_compras_prepedido_pvc_pendientes/verificado`,
                        contador_verificado: `${$BASE_REST}/view_compras_prepedido_pvc_pendientes/verificado?contadores=1`,
                        generado: `${$BASE_REST}/view_compras_pedidos_pvc_pendientes_oc/generado`,
                        contador_generado: `${$BASE_REST}/view_compras_pedidos_pvc_pendientes_oc/generado?contadores=1`,
                        enviado: `${$BASE_REST}/view_compras_pedidos_pvc_pendientes_oc/enviado`,
                        contador_enviado: `${$BASE_REST}/view_compras_pedidos_pvc_pendientes_oc/enviado?contadores=1`,
                        contestado: `${$BASE_REST}/view_compras_pedidos_pvc_pendientes_oc/contestado`,
                        contador_contestado: `${$BASE_REST}/view_compras_pedidos_pvc_pendientes_oc/contestado?contadores=1`,
                        pendiente_recepcion: `${$BASE_REST}/view_compras_pedidos_pvc_oc/pendiente_recepcion`,
                        contador_pendiente_recepcion: `${$BASE_REST}/view_compras_pedidos_pvc_oc/pendiente_recepcion?contadores=1`,
                        recibido_parcial: `${$BASE_REST}/view_compras_pedidos_pvc_oc/recibido_parcial`,
                        contador_recibido_parcial: `${$BASE_REST}/view_compras_pedidos_pvc_oc/recibido_parcial?contadores=1`,
                        recibido_total: `${$BASE_REST}/view_compras_pedidos_pvc_oc/recibido_total`,
                        contador_recibido_total: `${$BASE_REST}/view_compras_pedidos_pvc_oc/recibido_total?contadores=1`,
                        // Endpoints para funcionalidades varias
                        view_prepedido_detalles: `${$BASE_REST}/view_prepedido_detalles`,
                        verificar_items_prepedido: `${$BASE_REST}/compras_prepedido/verificar_items_prepedido`,
                        ver_pdf: `${$BASE_REST}/venta/reporte_venta_pdf`
                  },
                  demorasOc: {
                        demoras: `${$BASE_REST}/view_orden_compra_demoras`,
                  },
                  inventarios: {
                        inventarios: `${$BASE_REST}/view_stock_inventarios`,
                        inventario_items: `${$BASE_REST}/view_stock_inventario_items`,
                        stock_inventario_items: `${$BASE_REST}/stock_inventario_items`,
                        stock_inventarios: `${$BASE_REST}/stock_inventarios`  
                  },
                  remitos_internos: {
                        remitos_internos: `${$BASE_REST}/view_remito_interno`,
                        remito_interno_item: `${$BASE_REST}/view_remito_interno_item`,
                  },
                  movimientos_internos: {
                        movimientos_internos: `${$BASE_REST}/view_stock_movimiento_interno`,
                        eliminar_movimiento_interno: `${$BASE_REST}/stock_movimiento/eliminar_movimiento_interno`,
                        movimiento_interno: `${$BASE_REST}/stock_movimiento/movimiento_interno`
                  },
                  movimientos_materiales: {
                        operario_por_venta: `${$BASE_REST}/egreso/operario_venta`,
                        egresos_por_operario: `${$BASE_REST}/egreso/egreso_operario_venta`
                  },
                  stock_panol: {
                        view_stock_panols: `${$BASE_REST}/view_stock_panols`,
                        stock_panols: `${$BASE_REST}/stock_panols`,
                  },
                  egresos: {
                        view_stock_egreso_movimiento: `${$BASE_REST}/view_stock_egreso_movimientos`,
                        view_stock_egreso_borrador: `${$BASE_REST}/view_stock_egreso_borrador`,
                        view_usuario_activo: `${$BASE_REST}/view_usuario_activo`,
                        stock_egreso_borrador: `${$BASE_REST}/stock_egreso_borrador`,
                        stock_egreso_borrador_update: `${$BASE_REST}/stock_egreso_borrador/update`,
                        stock_movimiento_egreso_pro: `${$BASE_REST}/stock_movimiento/egreso_pro`,
                        view_venta: `${$BASE_REST}/view_venta`,
                        pro_imagens: `${$BASE_REST}/pro_imagens`,
                        devolver: `${$BASE_REST}/stock_movimiento/devolver`
                  }
            },
            taller: {
                  planta_pintura: {
                        delete_remito_ppitem: `${$BASE_REST}/compras_remito_pp_item/eliminar_perfil`,
                        remitospp: `${$BASE_REST}/compras_remito_pps`,
                        remitospp_vista: `${$BASE_REST}/view_compras_remito_pps`,
                        proveedores: `${$BASE_REST}/proveedors`,
                        remito_pp_perfil_pendientes_vista: `${$BASE_REST}/view_compras_remito_pp_perfil_pendientes`,
                        remito_pp_items: `${$BASE_REST}/compras_remito_pp_items`,
                        remito_pp_items_vista: `${$BASE_REST}/view_compras_remito_pp_items`,
                        remito_pp_perfil_ocs_vista: `${$BASE_REST}/view_compras_remito_pp_perfil_ocs`,
                        tratamientos: `${$BASE_REST}/tratamientos`,
                        remitopp_tratamiento_perfiles_vista: `${$BASE_REST}/view_compras_remito_pp_tratamiento_perfils`,
                        tratamiento_ventas: `${$BASE_REST}/view_compras_remito_pp_tratamiento_ventas`,
                        remitopp_guardar_interno: `${$BASE_REST}/compras_remito_pp/guardar_interno`,
                        remitopp_guardar_items: `${$BASE_REST}/compras_remito_pp/guardar_items`,
                        documentos_remito_pp: `${$DOCUMENTOS}/remito_pp`,
                        notificar: `${$BASE_REST}/compras_remito_pp/notificar`
                  },
                  remitos_aasa: {
                        remitos_aasa: `${$BASE_REST}/remito_aasas`,
                        remito_aasa_items: `${$BASE_REST}/remito_aasa_items`,
                        proveedor_pendientes: `${$BASE_REST}/proveedor_pendientes`,
                        remitopp_pendientes: `${$BASE_REST}/remitopp_pendientes`,
                        tratamiento_pendientes: `${$BASE_REST}/tratamiento_pendientes`,
                        compras_remito_aasa_item_procesos: `${$BASE_REST}/compras_remito_aasa_item_procesos`,
                        remito_aasa_internos: `${$BASE_REST}/remito_aasa_internos`,
                        view_compras_remito_aasa_item_asignacions: `${$BASE_REST}/view_compras_remito_aasa_item_asignacions`,
                        compra_remitos_aasa: `${$BASE_REST}/compras_remito_aasas`,
                  },
                  orden_trabajo: {
                        orden_trabajo: `${$BASE_REST}/orden_trabajos`,
                        view_ot: `${$BASE_REST}/view_taller_ots`
                  }
            },
            reportes: {
                  view_empleado_planilla_sueldos: `${$BASE_REST}/view_empleado_planilla_sueldos`,
                  view_egreso_cantidad_kilo: `${$BASE_REST}/view_egreso_cantidad_kilos`,
                  view_egreso_retencion_pago: `${$BASE_REST}/view_egreso_retencion_pagos`,
                  view_venta_comprobante: `${$BASE_REST}/view_venta_comprobantes`,
                  view_venta_comprobante_download_zip: `${$BASE_REST}/view_venta_comprobante/download_zip`,
                  actualizar_fecha_pago: `${$BASE_REST}/view_empleado_planilla_sueldo/actualizar_fecha_pago`,
                  vehiculos: `${$BASE_REST}/view_internos`
            },
            rrhh: {
                  postulantes: $BUSQUEDAS,
            },
            configuraciones: {
                  precios: {
                        configuraciones: `${$BASE_REST}/configuracions`,
                        tamanoVidrios: `${$BASE_REST}/tamano_vidrios`,
                        precioPuertaChapa: `${$BASE_REST}/view_precios_puerta_chapas`,
                        tratamientoCortina: `${$BASE_REST}/view_cortina_tratamientos`,
                        puertaAluminio: `${$BASE_REST}/view_precios_puerta_aluminios`,
                        configuracion_precios: `${$BASE_REST}/configuracion_precios`,
                  },
                  zonas: {
                        zonas: `${$BASE_REST}/zonas`,
                  },
                  puertas_interior: {
                        puerta_placas: `${$BASE_REST}/puerta_placas`,//
                        marca_puerta_placas: `${$BASE_REST}/marca_puerta_placas`,
                        linea_puerta_placas: `${$BASE_REST}/linea_puerta_placas`,
                        tipo_puerta_placas: `${$BASE_REST}/tipo_puerta_placas`,
                        marcos: `${$BASE_REST}/marcos`,
                        emplacados: `${$BASE_REST}/emplacados`,
                        acabados: `${$BASE_REST}/acabados`,
                        medidas: `${$BASE_REST}/medidas`,
                        modelos: `${$BASE_REST}/modelos`,
                        aplicar_precio_masivo: `${$BASE_REST}/puerta_placa/aplicar_precio_masivo`,
                        calcular_precio_venta: `${$BASE_REST}/puerta_placa/calcular_precio_venta`,
                  }
            },
            calculadora: {
                  abertura_lista: {
                        lineas: `${$BASE_REST}/lineas`,
                        tratamientos: `${$BASE_REST}/tratamientos`,
                        tratamiento_aluminios: `${$BASE_REST}/tratamiento_aluminios`,
                        ubicacions: `${$BASE_REST}/ubicacions`,
                        linea_tipos: `${$BASE_REST}/view_abertura_lista_linea_tipos`,
                        tipo_mosquiteros: `${$BASE_REST}/aberturalista/tipo_mosquiteros`,
                        vidrio_cotizacion: `${$BASE_REST}/view_vidrio_cotizacion`,
                        categoria_vidrios: `${$BASE_REST}/categoriavidrios`,
                        camaras: `${$BASE_REST}/camaras`,
                        aberturalista_calcular: `${$BASE_REST}/aberturalista/calcular`,
                        aberturalistas: `${$BASE_REST}/aberturalistas`
                  },
                  abertura_editable: {
                        aberturamanual_limpiar: `${$BASE_REST}/aberturamanual/limpiar`,
                        get_itemalternativa_borrador: `${$BASE_REST}/aberturamanual/get_itemalternativa_borrador`,
                  },
                  puerta_lista: {
                        lineas: `${$BASE_REST}/lineas`,
                        tratamientos: `${$BASE_REST}/tratamientos`,
                        tratamiento_aluminios: `${$BASE_REST}/tratamiento_aluminios`,
                        ubicacions: `${$BASE_REST}/ubicacions`,
                        tipo_mosquiteros: `${$BASE_REST}/aberturalista/tipo_mosquiteros`,
                        vidrio_cotizacion: `${$BASE_REST}/view_vidrio_cotizacion`,
                        categoria_vidrios: `${$BASE_REST}/categoriavidrios`,
                        camaras: `${$BASE_REST}/camaras`,
                        aberturapuertalista_calcular: `${$BASE_REST}/aberturapuertalista/calcular`,
                        view_puerta_lista_linea_tipos: `${$BASE_REST}/view_puerta_lista_linea_tipos`,
                        aberturapuertalistas: `${$BASE_REST}/aberturapuertalistas`,
                        //view_puerta_lista_linea_tipos?filter[idlinea]=3&expand=imagen_data
                  },
                  puerta_chapa: {
                        modelos: `${$BASE_REST}/puertachapas`,
                        aberturapuertachapa_calcular: `${$BASE_REST}/aberturapuertachapa/calcular`,
                        aberturapuertachapas: `${$BASE_REST}/aberturapuertachapas`,
                  },
                  puerta_interior: {
                        ubicacions: `${$BASE_REST}/ubicacions`,
                        marco: `${$BASE_REST}/view_puerta_interior_marcos?`,
                        emplacado: `${$BASE_REST}/view_puerta_interior_emplacados?`,
                        acabado: `${$BASE_REST}/view_puerta_interior_acabados?`,
                        muro: `${$BASE_REST}/view_puerta_interior_muros?`,
                        medida: `${$BASE_REST}/view_puerta_interior_medidas?`,
                        marca: `${$BASE_REST}/marca_puerta_placas?expand=imagen_data&filter[activo]=1`,
                        modelo: `${$BASE_REST}/view_puerta_interior_modelos?expand=imagen_data&`,
                        tipo: `${$BASE_REST}/view_puerta_interior_tipos?expand=imagen_data&`,
                        aberturapuertaplaca_calcular: `${$BASE_REST}/aberturapuertaplaca/calcular`,
                        aberturapuertaplacas: `${$BASE_REST}/aberturapuertaplacas`
                  }
            },
            calculadora_vidrios: {
                  calcular: `${$BASE_REST}/itemalternativa/calculadora_vidrio`,
                  get_camaras: `${$BASE_REST}/camaras`,
                  get_categoria_vidrios: `${$BASE_REST}/categoriavidrios`,
            }
      },
      /* rol: {
            vendedor: [
                  { sector: '', id: 56 },
                  { sector: '', id: 65 },
                  { sector: '', id: 71 }
            ],
            admin: 54,
            analista: 69
      } */
};
